import {InGameChallengesLiveProgressUpdateModel} from "./live-progress-update-topic.model";
import {IServiceFactoryExtended} from "../../../../service-factory-extended.interface";
import {ITriple8Connection} from "../../../triple8/triple8-connection.inteface";
import {ILiveProgressUpdateTopicFactory} from "./live-progress-update-topic-factory.interface";
import {IFirebaseTopicModel} from "../../firebase-topic-model.interface";

export class LiveProgressUpdateTopicFactory implements ILiveProgressUpdateTopicFactory, IFirebaseTopicModel {
    constructor(protected readonly services: IServiceFactoryExtended,
        protected readonly getConnection: () => Promise<ITriple8Connection>) {
    }


    private _campaigns: Record<number, InGameChallengesLiveProgressUpdateModel> = {};

    getLiveProgressForCampaign(campaignId: number): InGameChallengesLiveProgressUpdateModel {
        if (!this._campaigns[campaignId]) {
            this._campaigns[campaignId] = new InGameChallengesLiveProgressUpdateModel(campaignId,
                this.services,
                () => this.getConnection());
        }
        this._campaigns[campaignId].subscribe();

        return this._campaigns[campaignId];
    }

    getTopicName(): string {
        //since this is a factory the topic name it doesn't really matter
        return "LiveProgressUpdateFactory";
    }

    getTopicLabel(): string {
        //since this is a factory the topic label it doesn't really matter
        return "LiveProgressUpdateFactory";
    }

    async subscribe(): Promise<void> {
        //we don't do anything here as the consumer of this topic will explicitly subscribe to a specific campaign
    }

    async unsubscribe(): Promise<void> {
        for (let campaignSubscription of Object.values(this._campaigns)) {
            await campaignSubscription.unsubscribe();
        }

        this._campaigns = {};
    }
}